export default __webpack_public_path__ + "static/media/spr-motion-large.94bad4bb.mp4";